import React, { lazy } from 'react';
const MarkdownRenderer = lazy(() => import('react-markdown-renderer'));

export default function LazyMarkdownRenderer({ ...props }) {
  return <MarkdownRenderer {...props} />;
}
